import React from 'react'
import PropTypes from 'prop-types'
import { FormControl, List, ListItem, ListItemText, Divider, Paper } from '@material-ui/core'
import './PropertySearchItem.scss'
import { withStyles } from '@material-ui/core/styles'

const styles = {
  root: {
    position: 'absolute',
    padding: '20px',
    width: '365px',
    maxHeight: '500px',
    overflow: 'auto',
    borderRadius: '2px',
    marginTop: '-8px'
  }
}

const PropertySearchItem = props => {

  const { classes, propertySearchDetails, closeIconDisplay, getPropertyInfo } = props

  const addProperty = id => {
    getPropertyInfo(id)
  }

   return (
    <>
    { propertySearchDetails.length > 0 && (
      <Paper
        data-testid="property-search-item"
        classes={{ root: classes.root }}
        aria-labelledby="project_filter"
      >
      <FormControl>
        <List>
          {propertySearchDetails.map((field, index) => (
            <div
              key={index}
              data-testid={`property-list-item-${index}`}
              className="property-list-item"
              onClick={() => addProperty(field.omniViewPropertyId)}
            >
              <ListItem button>
              <ListItemText
                primary={field.propertyName}
                secondary={
                  <React.Fragment>
                    {field.city},{field.state}
                  </React.Fragment>
                }
              />
              </ListItem>
              <Divider />
            </div>
          ))}
        </List>
      </FormControl>
    </Paper>
    )}

    {
      (closeIconDisplay && propertySearchDetails.length === 0) && (
        <span > No properties found!</span>
      )
    }

    </>
  )
}

PropertySearchItem.propTypes = {
  classes: PropTypes.object,
  propertySearchDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  closeIconDisplay: PropTypes.bool,
  getPropertyInfo: PropTypes.func
}

export default withStyles(styles)(PropertySearchItem)
